import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

/**
 * 認証、認可情報の状態
 */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
